import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import user from './modules/user'
import permission from './modules/permission'
import tagsView, { persistVisitedViews } from './modules/tagsView'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    user,
    permission,
    tagsView
  },
  getters
})

// 标签变更时同步到会话存储，浏览器刷新后恢复
store.subscribe(mutation => {
  if (mutation.type.indexOf('VISITED_VIEW') > -1) {
    persistVisitedViews(store.state.tagsView.visitedViews)
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js